/* UserLocalStorage.js */

"use strict";
const _ = require("lodash");

/**
 * Local UserLocalStorage class,
 * stores the local instance of the local storage,
 * and methods to work with it.
 * Should be created with UserDataStorageFactory class method getLocalStorageInstance()
 */
class UserLocalStorage {
    constructor(logger, userSession) {
        this._log = logger;
        this._userSession = userSession;
        //this._userId = ;
        this._userId = undefined;
    }

    getItem(keyString) {
        if (this.userId) {
            try {
                let storageObj = window.localStorage.getItem(`Steve.${this.userId}.${keyString}`);
                if (storageObj) {
                    return JSON.parse(storageObj);
                } else {
                    return null;
                }
            } catch (err) {
                this._log.error("Unable to retrieve LocalStorage object.");
            }
        } else {
            this._log.error("need a logged in user to get LocalStorage");
        }
    }

    setItem(key, obj) {
        if (this.userId) {
            let keyString = `Steve.${this.userId}.${key}`;
            try {
                window.localStorage.setItem(keyString, JSON.stringify(obj));
            } catch (e) {
                this._log.error(e);
            }
        } else {
            this._log.warn("need a logged in user to set LocalStorage");
        }
    }

    get activeOrganization() {
        return this.getActiveOrganization();
    }

    set activeOrganization(obj) {
        this.setActiveOrganization(obj);
    }

    getActiveOrganization() {
        return this.getItem("activeOrganization");
    }

    setActiveOrganization(obj) {
        this.setItem("activeOrganization", obj);
    }

    get userId() {
        return this.getUserId();
    }

    set userId(id) {
        this.setUserId(id);
    }

    getUserId() {
        return _.get(this._userSession, "user.id") || _.get(this._userSession, "userId") || this._userId;
    }

    setUserId(id) {
        this._userId = id;
    }

    get token() {
        return this.getToken();
    }

    set token(token) {
        this.setToken(token);
    }

    getToken() {
        try {
            let expireTokenTime = Number(window.localStorage.getItem('Steve.session.expireTokenTime'));
            if (_.isNumber(expireTokenTime) && expireTokenTime < Date.now()) {
                window.localStorage.removeItem('Steve.session.token');
            }
            return window.localStorage.getItem('Steve.session.token');
        } catch (err) {
            this._log.error("Unable to retrieve LocalStorage object.");
        }
    }

    setToken(token) {
        try {
            if (token) {
                window.localStorage.setItem('Steve.session.token', token);
            } else {
                window.localStorage.removeItem('Steve.session.token');
            }
        } catch (e) {
            this._log.error(e);
        }
    }
}

module.exports = UserLocalStorage;
module.exports.$inject = ['$teve.logger', '$teve.userSession'];